import { React, useState } from 'react';
import Sidebarnew from './Sidebarnew';
import Footer from './Footer';
import Header from './Header';
import Dashboard from './Dashboard';

function Main({ element: Component }) {
	const [expanded, setExpanded] = useState(true);

	const toggleWidth = () => {
		setExpanded(!expanded);
	};


	return (
		<>
			<div className={`container-fluid  ${expanded ? "expanded" : "collapsed"}`}>
				<div className="row ms-0 me-0">
					<Sidebarnew expanded={expanded} />
					<div className="col ps-0 pe-0 mobile_toggle">
						<Header toggleWidth={toggleWidth} />
						<Component />


					</div>
					<Footer />
				</div>
			</div>
		</>
	);
}

export default Main;
